import { parsePhoneNumberFromString } from 'libphonenumber-js/mobile'

const removePlus = phone => phone.replace('+', '')
const addPlus = phone => `+${removePlus(phone)}`

// NOTE: that version of lib smaller than original, but anyway 105kb (unzip)
// FIXME: Better to move that validation to the server or external API
/**
 * @param  {string} number Number in any format
 * @return {boolean}       Is phone number valid (code exist, number of digits etc)
 */
export const validate = number => {
  number = addPlus(String(number))
  const phone = parsePhoneNumberFromString(number)
  if (!phone) return false
  return phone.isValid()
}
